import { Component, EventEmitter, Inject, Input, OnInit } from '@angular/core';
import { mergeMap } from 'rxjs/operators';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { IntegrationDao } from '../../../../core/services/dao/integrationDao';
import { User } from '../../../../core/models/user';
import { IntegrationInvite } from '../../../../core/models/integrationInvite';

@Component({
  selector: 'google-drive',
  templateUrl: './google-drive.component.html',
  styleUrls: ['./google-drive.component.scss']
})
export class GoogleDriveComponent implements OnInit {
    loading = false;
    editing = false;
    submitLoading = false;

    drives = [];
    selectedDrive: any;
    sharedDrive: boolean;

    @Input() brandId: string;
    @Input() code: string;

    subs = [];
    oauthURL;
    noDrives = false;
    existingIntegrations = [];
    createdIntegration: any = {};
    creating = false;
    user: User;
    invites: IntegrationInvite[];
    description: string = '';
    showAccounts = false;
    integrationName;
    integrationType;
    noAccounts = false;
    isAdmin = false;
    emitter: EventEmitter<any>;

    constructor(
        public dialogRef: MatDialogRef<GoogleDriveComponent>,
        public integrationDao: IntegrationDao,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        this.existingIntegrations = this.data.existingIntegrations;
        this.user = this.data.user;
        this.isAdmin = this.user ? this.user.isAdmin : false;
        this.invites = this.data.invites.filter(i => i.integrations.includes(this.data.type));
        this.description = this.data.description;
        this.integrationName = this.data.name;
        this.integrationType = this.data.type;
        this.emitter = this.data.emitter;
        if (this.existingIntegrations.length === 0) {
            this.creating = true;
            this.noAccounts = true;
        }
    }

    ngOnInit() {
        // let sub = this.integrationDao.getDriveOAuthUrl(this.data.brand).subscribe(res => {
        //     this.oauthURL = res['url'];
        // });
        // this.subs.push(sub);
    }

    onViewInvitesClick() {
        this.emitter.emit(this.integrationType);
        this.dialogRef.close();
    }

    toggleShowAccounts() {
        this.showAccounts = !this.showAccounts;
    }

    addAnother(e) {
        this.creating = true;
    }

    update() {
        if (!this.selectedDrive) {
            this.selectedDrive = { driveName: 'Personal', driveId: 0 };
        }
        this.createdIntegration.sharedDrive = this.selectedDrive.id !== 0;
        this.createdIntegration.driveName = this.selectedDrive.name;
        if (this.createdIntegration.sharedDrive) {
            this.createdIntegration.driveId = this.selectedDrive.id;
        }
        // this.integrationDao.updateDrive(this.createdIntegration).subscribe(res => {
        //     this.dialogRef.close(res)
        // });
    }

    onClick() {
        let opened = window.open(this.oauthURL, null, 'width=800,height=850,modal=yes,alwaysRaised=yes');

        let listener = event => {
            if (event.data) {
                if (event.data.type && event.data.type === 'google_drive' && event.data.id !== undefined) {
                    this.loading = true;
                    this.noDrives = false;
                    let intSub = this.integrationDao
                        .loadById(event.data.id)
                        .pipe(
                            // mergeMap(res => {
                            //     this.createdIntegration = res;
                            //    // return this.integrationDao.getGoogleDrives(this.createdIntegration.id);
                            // })
                        )
                        .subscribe(drives => {
                            this.drives = drives;
                            this.editing = true;
                            if (!this.drives.length) {
                                this.noDrives = true;
                            }
                            this.loading = false;
                        });
                    this.subs.push(intSub);

                    // remove listener
                    window.removeEventListener('message', listener);

                    // close window
                    opened.close();
                }
            }
        }

        window.addEventListener('message', listener);
    }

    ngOnDestroy(): void {
        this.subs.forEach(sub => sub.unsubscribe());
    }
}
